<div class="title">
  <h2>{{ 'deliveryMode.title' | transloco }}</h2>
</div>
@if (supportedDeliveryMethods$(); as supportedDeliveryMethods) {
  <div class="deliveryMode">
    @for (mode of supportedDeliveryMethods; track mode) {
      <div class="deliveryMode-mode" (click)="setDeliveryMode(mode)">
        <div class="icon-container">
          <div class="icon">
            <img
              aria-hidden="true"
              src="/assets/images/icons/shipping/{{ mode.code }}.svg"
              loading="lazy"
              [alt]="mode.name"
            />
          </div>
        </div>
        <div class="button-mode">
          <button boelsButton variant="primary-brand">
            {{ mode.name }}
          </button>
        </div>
        <div class="message">
          @if (mode.code === DeliveryModeType.DELIVERY) {
            <span class="text-subtle-gray_1000">
              {{ 'deliveryMode.transportationCostsNotice' | transloco }}
            </span>
          }
        </div>
      </div>
    }
  </div>
} @else {
  <boels-spinner></boels-spinner>
}

<hr class="divider" />

<div class="button-back">
  <button
    boelsButton
    variant="secondary"
    action="none"
    [icon]="faChevronLeft"
    (click)="back()"
  >
    {{ 'deliveryMode.back' | transloco }}
  </button>
</div>

<ng-template #loading>
  <boels-spinner></boels-spinner>
</ng-template>
